import EventBus from './eventBus'
import _ from 'lodash'
import moment from 'moment'
import {cantonnierName} from '../filters'
import state from './state'

export default {
  //
  // Commons
  //
  LOADING (state, message) {
    state.loading.overlay = true
    state.loading.message = message
  },
  //
  // Login
  //
  LOGIN_ERROR (state, message) {
    state.login.message = message
    state.loading.overlay = false
  },
  LOGIN_SUCCESS (state, {ville, role, id, arrondissement_id}) {
    state.currentVille.id = ville.id
    state.currentVille.name = ville.nom
    state.currentVille.coords.lat = ville.lat
    state.currentVille.coords.lon = ville.lon
    state.currentVille.arrondissements = ville.arrondissements.sort((a, b) => a.nom.localeCompare(b.nom))
    state.currentVille.secteurs = ville.secteurs
    state.currentVille.materielsPermis = ville.materielPermiss
    state.currentVille.moduleBackoffice = ville.parametragebos
    state.currentVille.module_android = ville.parametrageapks
    state.currentUser.role = role
    state.currentUser.id = id
    state.currentUser.arrondissement_id = arrondissement_id
    state.currentUser.arrondissementName = state.currentVille.arrondissements.find(a => a.id === state.currentUser.arrondissement_id).nom

    console.log('Yeeeeeeeeeeeeeeeeeeeeeees => ', state.currentUser.arrondissementName)
    state.login.loggedIn = true
    state.loading.overlay = false
    state.login.message = null

  },
  LOGOUT_SUCCESS (state) {

    state.login.loggedIn = false
    state.loading.overlay = false
    localStorage.clear()
    EventBus.$emit('notify', {
      title: 'Vous avez bien été déconnecté.',
      type: 'success',
    })
    // window.location.reload()
    console.log('We continuuuuuuuuuuuuu 2')
  },
  FORGOT_PASSWORD_SUCCESS (state) {
    state.loading.overlay = false
    EventBus.$emit('notify', {
      title: 'Un mail vient de vous être envoyé.',
      type: 'success',
    })
  },
  PASSWORD_UPDATED_SUCCESS (state) {
    state.loading.overlay = false
    state.login.message = null
    EventBus.$emit('notify', {
      title: 'Votre mot de passe a bien été changé.',
      type: 'success',
    })
  },
  PASSWORD_UPDATED_ERROR (state, message) {
    state.login.message = message
    state.loading.overlay = false
  },

  //tournees

MODULE_TOURNEES_FETCHED (state, tournees) {
    state.tournees.data = tournees
    state.loading.overlay = false
  },
  //
  // Maitrises
  //
  MAITRISES_CLEARED (state) {
    state.maitrises.data = []
  },
  MAITRISES_DELETED (state, maitrise) {
    state.allUsers.data = state.allUsers.data.filter(item => item.meta.id !== maitrise.meta.id)
    state.loading.overlay = false
    EventBus.$emit('notify', {
      title: 'Utilisateur supprimé définitivement',
      type: 'success',
    })
  },
  MAITRISE_UPDATED (state, maitrise) {
    updateArray(state.maitrises.data, maitrise)
    updateArray(state.maitrises.filteredMaitrises, maitrise)
    state.loading.overlay = false
    EventBus.$emit('notify', {
      title: 'Maîtrise mis à jour.',
      type: 'success',
    })
  },
  MAITRISE_CREATED (state, maitrise) {
    state.maitrises.data.unshift(maitrise)

    let sortedData = [...state.maitrises.data].sort((a, b) => a.nom.localeCompare(b.nom))
    state.maitrises.treeSelectMaitrises = [{id: '1', label: 'Tous les maitrises', children: []},]
    var tempMaitrisesMap = new Map()
    sortedData.forEach((mait) => {
      tempMaitrisesMap.set(mait.id, {id: mait.id, label: mait.nom + ' ' + mait.prenom})
    })
    state.maitrises.treeSelectMaitrises[0].children = Array.from(tempMaitrisesMap.values())

    state.loading.overlay = false
    EventBus.$emit('notify', {
      title: 'Maîtrise créé.',
      type: 'success',
    })
  },
  ALL_MAITRISES_FETCHED (state, maitrises) {
    state.maitrises.allData = maitrises
    state.loading.overlay = false
  },
  MAITRISES_FETCHED (state, maitrises) {
    console.log('Maitrises from mutation => ', maitrises)
    state.maitrises.filters.idMaitrises = []
    state.maitrises.data = maitrises
    state.maitrises.filteredMaitrises = maitrises
    state.maitrises.treeSelectMaitrises = [{id: '1', label: 'Tous les maitrises', children: []},]
    var treeSelectOptions = new Map()
    maitrises.forEach((mait) => {
      treeSelectOptions.set(mait.id, {id: mait.id, label: mait.nom + ' ' + mait.prenom})
    })
    state.maitrises.treeSelectMaitrises[0].children = Array.from(treeSelectOptions.values())
    state.loading.overlay = false
  },
  MAITRISE_DEACTIVATED (state, maitrise) {
    console.log('deactivated this', maitrise.id)
    updateArray(state.maitrises.data, maitrise)
    updateArray(state.maitrises.filteredMaitrises, maitrise)
    console.log('state mait ========', state.maitrises)
    state.loading.overlay = false
    EventBus.$emit('notify', {
      title: 'Maîtrise supprimé.',
      type: 'success',
    })
  },

  //
  // Arrondissements
  //

  ALL_ARRONDISSEMENTS_FETCHED (state, allArrondissements) {
    state.allArrondissements.data = allArrondissements
    //state.loading.overlay = false
  },
  ARRONDISSEMENTS_FETCHED (state, arrondissements) {
    console.log('Arrondissements from mutation => ', arrondissements)
    state.arrondissements.data = arrondissements
  },
  ALL_ARRONDISSEMENTS_ERROR (state, result) {
    state.loading.overlay = false
    var errorMessage = result.err.message
    if (result.err.message === 'Network Error') {
      errorMessage = 'Problème de communication avec le Backend'
    } else if (result.err.response) {
      if (result.err.response.status === 500) {
        errorMessage = 'Erreur serveur interne'
      } else if (result.err.response.status === 403) {
        errorMessage = 'Vous n\'etes pas autorisé à consulter cette page'
      } else if (result.err.response.status === 401) {
        errorMessage = 'Erreur d\'authentification'
      }
    }
    EventBus.$emit('notify', {
      title: 'Erreur lors de la ' + result.action + ' des arrondissements 😦 : ' + errorMessage,
      type: 'danger',
    })
  },

  //
  // Secteurs
  //

  SECTEURS_FETCHED (state, secteurs) {
    state.secteurs.data = secteurs
    state.loading.overlay = false
    EventBus.$emit('notify', {
      title: 'Secteurs récupérés.',
      type: 'success',
    })
  },
  SECTEUR_CREATED (state, result) {
    state.secteurs.data.unshift(result)
    state.loading.overlay = false
    EventBus.$emit('notify', {
      title: 'Secteur créé.',
      type: 'success',
    })
  },
  SECTEUR_UPDATED (state, secteur) {
    console.log(secteur)
    updateArray(state.secteurs.data, secteur)
    state.loading.overlay = false
    EventBus.$emit('notify', {
      title: 'Secteur mis à jour.',
      type: 'success',
    })
  },
  SECTEUR_DEACTIVATED (state, secteur) {
    console.log(secteur)
    removeFromArray(state.secteurs.data, secteur)
    state.loading.overlay = false
    EventBus.$emit('notify', {
      title: 'Cantonnier supprimé.',
      type: 'success',
    })
  },
  SECTEUR_ERROR (state, result) {
    state.loading.overlay = false
    var errorMessage = result.err.message
    if (result.err.message === 'Network Error') {
      errorMessage = 'Problème de communication avec le Backend'
    } else if (result.err.response) {
      if (result.err.response.status === 500) {
        errorMessage = 'Erreur serveur interne'
      } else if (result.err.response.status === 403) {
        errorMessage = 'Vous n\'etes pas autorisé à consulter cette page'
      } else if (result.err.response.status === 401) {
        errorMessage = 'Erreur d\'authentification'
      }
    }
    EventBus.$emit('notify', {
      title: 'Erreur lors de la ' + result.action + ' des secteurs 😦 : ' + errorMessage,
      type: 'danger',
    })
  },
  SECTEURS_ERROR (state, err) {
    console.error(err)
    state.loading.overlay = false
    EventBus.$emit('notify', {
      title: 'Erreur à la récupération des secteurs =(',
      type: 'danger',
    })
  },

  //
  // IMPLANTATION
  //

  TOURNEES_FETCHED (state, tournees) {
    state.loading.overlay = false
    state.map.message = null
    state.materiels.dataTournees = []
    state.materiels.actif = true
    state.map.result.remontees = []
    state.map.filters.idTournee = ''
    state.map.filters.idMateriel = ''
    state.map.infoTournee.idMateriel = ''
    state.map.infoTournee.nomMateriel = ''
    state.map.infoTournee.cantonnier = ''
    state.map.infoTournee.duree = ''
    // alimenter le filtre des matériels par les materiels utilisés pour effectuer les tournées

    console.log('Current User =>  ', state.currentUser)
    if (state.currentUser.arrondissementName.includes('2') || state.currentUser.arrondissementName.includes('Sud')) {
      let filtredTournees = []
      tournees.forEach((t) => {

        if (t.remonteeGPSs.length > 0){
          let arrondissement = state.currentVille.secteurs.find(s => s.id === t.remonteeGPSs[0].secteur_id).arrondissement_id
          if (arrondissement === state.currentUser.arrondissement_id) {
            filtredTournees.push(t)
          }
        }
      })

      state.map.result.dataTournees = filtredTournees
      state.map.result.tournees = filtredTournees

    } else {
      state.map.result.dataTournees = tournees
      state.map.result.tournees = tournees
    }

    state.map.result.tournees.forEach((t) => {
      let materiel = state.materiels.data.find(m => m.id === t.materiel_id)
      let exist = state.materiels.dataTournees.find(m => m.id === materiel.id)
      if (!exist) {
        state.materiels.dataTournees.push(materiel)
      }
    })

    if (state.map.result.tournees && state.map.result.tournees.length === 0) {
      state.map.message = {
        text: 'Aucun point GPS correspondant',
        type: 'warning',
      }
    }
    EventBus.$emit('reload', {})
  },
  REMONTEES_GPS_FETCHED (state, tournee) {
    state.map.result.remontees = tournee.remonteeGPSs
    state.map.result.tournees = []
    // garder que le materiel utilisé dans cettte tournée
    state.materiels.dataRemontees = state.materiels.data.filter(m => m.id === state.map.filters.idMateriel)
    state.materiels.actif = false
    EventBus.$emit('reload', {})
  },
  DECLARATIONS_FETCHED (state, declaration) {
    state.map.result.declarations = []
    state.map.result.infoDeclarations = []

    if (declaration.data.length > 0) {
      const arr = declaration.data.map(obj => ({...obj, opened: false})) // ajouter l'attribut opened
      state.map.result.declarations = arr
      state.map.result.infoDeclarations = declaration.info
    }
    state.loading.overlay = false
  },
  TOURNEES_FILTERED (state, id_materiel) {

    if (id_materiel) { // si un materiel est séléctionner un filtre s'applique pour garder que les tournées réalisées par ce materiel
      state.map.result.tournees = state.map.result.dataTournees.filter(t => t.materiel_id === id_materiel)
    } else { // si aucun materiel est séléctionner le filtre ne s'applique plus
      state.map.result.tournees = state.map.result.dataTournees
    }
    EventBus.$emit('reload', {})
  },
  INFO_TOURNEE (state, {info}) {
    state.map.infoTournee = info
  },

  //
  // CANTENANT
  //

  CONTENANT_DEACTIVATED (state, contenant) {
    console.log(contenant)
    removeFromArray(state.contenants.data, contenant)
    removeFromArray(state.contenants.filtredContenants, contenant)
    state.contenants.availablesNumeros = [{id: '1', label: 'Tous les numéros de contenants', children: []},]
    var tempNumeroMap = new Map()
    state.contenants.data.forEach((c) => {
      tempNumeroMap.set(c.id, {id: c.id, label: c.reference, isDisabled: false})
    })
    state.contenants.availablesNumeros[0].children = Array.from(tempNumeroMap.values())
    state.loading.overlay = false
    EventBus.$emit('notify', {
      title: 'Contenant supprimé.',
      type: 'success',
    })
  },
  CONTENANT_UPDATED (state, contenant) {
    console.log(contenant)
    updateArray(state.contenants.data, contenant)
    state.loading.overlay = false
    EventBus.$emit('notify', {
      title: 'Contenant mis à jour.',
      type: 'success',
    })
  },
  CONTENANT_CREATED (state, contenant) {
    state.contenants.data.unshift(contenant)
    let sortedData = [...state.contenants.data].sort((a, b) => a.reference.localeCompare(b.reference))
    state.contenants.availablesNumeros = [{id: '1', label: 'Tous les numéros de contenants', children: []},]
    var tempNumeroMap = new Map()
    sortedData.forEach((c) => {
      tempNumeroMap.set(c.id, {id: c.id, label: c.reference, isDisabled: false})
    })
    state.contenants.availablesNumeros[0].children = Array.from(tempNumeroMap.values())

    state.loading.overlay = false
    EventBus.$emit('notify', {
      title: 'Contenant créé.',
      type: 'success',
    })
  },
  CONTENANTS_ERROR (state, result) {
    state.loading.overlay = false
    var errorMessage = result.err.message
    if (result.err.message === 'Network Error') {
      errorMessage = 'Problème de communication avec le Backend'
    } else if (result.err.response) {
      if (result.err.response.status === 500) {
        errorMessage = 'Erreur serveur interne'
      } else if (result.err.response.status === 403) {
        errorMessage = 'Vous n\'etes pas autorisé à consulter cette page'
      } else if (result.err.response.status === 401) {
        errorMessage = 'Erreur d\'authentification'
      } else if (result.err.response.status === 409) {
        errorMessage = 'Un contenant avec la même Référence existe déjà dans la BD'
      }
    }
    EventBus.$emit('notify', {
      title: 'Erreur lors de la ' + result.action + ' des contenants 😦 : ' + errorMessage,
      type: 'danger',
    })
  },
  CONTENANTS_FETCHED (state, {contenants, arg}) {

    const arr = contenants.map(obj => ({...obj, opened: false})) // ajouter l'attribut opened
    arr.sort((a, b) => a.reference - b.reference)
    state.implentationContenants.data = arr
    state.implentationContenants.fitredData = arr
    console.log('contenants-state => ', state.implentationContenants.data)

    if (arg === 'contenants') {

      state.contenants.data = arr
      state.contenants.filtredContenants = arr
      state.contenants.availableSecteurs = [{id: '1', label: 'Tous les secteurs', children: []},]
      state.contenants.availablesNumeros = [{id: '1', label: 'Tous les numéros de contenants', children: []},]
      state.contenants.availablesAdresses = [{id: '1', label: 'Toutes les adresses', children: []},]

      var tempSecteursMap = new Map()
      var tempNumeroMap = new Map()
      var tempAdressesMap = new Map()

      _.map(state.contenants.data, function (contenant) {
        tempSecteursMap.set(contenant.secteur_id, {
          id: contenant.secteur_id,
          label: getSecteurName(contenant.secteur_id),
          isDisabled: false
        })
        tempNumeroMap.set(contenant.reference, {id: contenant.id, label: contenant.reference, isDisabled: false})
        tempAdressesMap.set(contenant.adresse, {id: contenant.adresse, label: contenant.adresse, isDisabled: false})
      })

      state.contenants.availablesNumeros[0].children = Array.from(tempNumeroMap.values())
      state.contenants.availablesAdresses[0].children = Array.from(tempAdressesMap.values())
      state.contenants.availableSecteurs[0].children = Array.from(tempSecteursMap.values())

      console.log('state of availablesNumeros => ', state.contenants.availablesNumeros[0].children)
      console.log('state of availablesAdresses => ', state.contenants.availablesAdresses[0].children)
      console.log('state of availableSecteurs => ', state.contenants.availableSecteurs[0].children)
      console.log('state of contenant => ', state.contenants.filtredContenants)
    }

    state.loading.overlay = false

    EventBus.$emit('notify', {
      title: 'Contenants récupérés.',
      type: 'success',
    })
  },
  ALL_CONTENANTS_FETCHED (state, contenants) {
    state.contenants.allData = contenants
    state.loading.overlay = false
  },
  CONTENANTS_FILTERED (state, filter) {
    console.log('filter getted => ', filter)
    console.log('overlay  => ', state.loading.overlay)
    let arr = state.implentationContenants.data
    console.log('arr to filter => ', arr)
    if (filter.idType || filter.idSecteur) {
      if (filter.idType) {
        arr = arr.filter(i => i.typeContenant === filter.idType)
      }
      if (filter.idSecteur) {
        arr = arr.filter(i => i.secteur_id === filter.idSecteur)
      }
      state.implentationContenants.fitredData = arr
    } else {
      state.implentationContenants.fitredData = arr
    }
  },

  //
  // Matériel
  //

  MATERIEL_CREATED (state, result) {
    state.materiels.data.unshift(result)
    state.loading.overlay = false
    EventBus.$emit('notify', {
      title: 'Materiel créé.',
      type: 'success',
    })
  },
  MATERIELS_ERROR (state, result) {
    state.loading.overlay = false
    var errorMessage = result.err.message
    if (result.err.message === 'Network Error') {
      errorMessage = 'Problème de communication avec le Backend'
    } else if (result.err.response) {
      if (result.err.response.status === 500) {
        errorMessage = 'Erreur serveur interne'
      } else if (result.err.response.status === 403) {
        errorMessage = 'Vous n\'etes pas autorisé à consulter cette page'
      } else if (result.err.response.status === 401) {
        errorMessage = 'Erreur d\'authentification'
      }
    }
    EventBus.$emit('notify', {
      title: 'Erreur lors de la ' + result.action + ' des materiels 😦 : ' + errorMessage,
      type: 'danger',
    })
  },
  MATERIEL_UPDATED (state, materiel) {
    console.log(materiel)
    updateArray(state.materiels.data, materiel)
    state.loading.overlay = false
    EventBus.$emit('notify', {
      title: 'Materiel mis à jour.',
      type: 'success',
    })
  },
  MATERIEL_DEACTIVATED (state, materiel) {
    console.log(materiel)
    removeFromArray(state.materiels.data, materiel)
    state.loading.overlay = false
    EventBus.$emit('notify', {
      title: 'Materiel supprimé.',
      type: 'success',
    })
  },
  ALL_MATERIELS_FETCHED (state, materiels) {
    state.materiels.allData = materiels
    state.loading.overlay = false
  },
  MATERIELSPERMIS_FETCHED (state, materielsPermis) {
    state.currentVille.materielsPermis = materielsPermis
  },
  MATERIELSPERMIS_ERROR (state, result) {
    state.loading.overlay = false
    var errorMessage = result.err.message
    if (result.err.message === 'Network Error') {
      errorMessage = 'Problème de communication avec le Backend'
    } else if (result.err.response) {
      if (result.err.response.status === 500) {
        errorMessage = 'Erreur serveur interne'
      } else if (result.err.response.status === 403) {
        errorMessage = 'Vous n\'etes pas autorisé à consulter cette page'
      } else if (result.err.response.status === 401) {
        errorMessage = 'Erreur d\'authentification'
      }
    }
    EventBus.$emit('notify', {
      title: 'Erreur lors de la ' + result.action + ' des materiauxs permis 😦 : ' + errorMessage,
      type: 'danger',
    })
  },
  MATERIELS_FETCHED (state, materiels) {
    state.materiels.data = materiels
    EventBus.$emit('notify', {
      title: 'Matériaux récupérés.',
      type: 'success',
    })
    console.log(window.location.href)
    if (!window.location.href.includes('reporting')) {
      state.loading.overlay = false
    }
  },

  //
  // collectes
  //

  COLLECTE_ERROR (state, err) {
    console.error(err)
    state.loading.overlay = false
    EventBus.$emit('notify', {
      title: 'Erreur à la récupération de la collecte =(',
      type: 'danger',
    })
  },
  COLLECTE_UPDATED (state, collecte) {
    const index = state.collectes.data.map(item => item.meta.id).indexOf(collecte.meta.id)
    state.collectes.data.splice(index, 1, Object.assign(state.collectes.data[index], collecte))
    state.loading.overlay = false
    EventBus.$emit('notify', {
      title: 'Collecte mis à jour.',
      type: 'success',
    })
  },
  COLLECTE_DOWNLOAD_TEMPLATE_FILE (state) {
    state.loading.overlay = false
    EventBus.$emit('notify', {
      title: 'Fichier template téléchargé',
      type: 'success',
    })
  },

  //
  // Cantonniers
  //

  CANTONNIERS_FETCHED (state, cantonniers) {
    state.cantonniers.data = cantonniers
    EventBus.$emit('notify', {
      title: 'Cantonniers récupérés.',
      type: 'success',
    })
    if (!window.location.href.includes('reporting')) {
      state.loading.overlay = false
    }
  },
  ALL_CANTONNIERS_FETCHED (state, cantonniers) {
    state.cantonniers.allData = cantonniers
    EventBus.$emit('notify', {
      title: 'Cantonniers récupérés.',
      type: 'success',
    })
    //  if (window.location.href.includes('cantonniers')) {
    state.loading.overlay = false
    //   }
  },
  CANTONNIER_CREATED (state, result) {
    state.cantonniers.data.unshift(result)
    state.loading.overlay = false
    EventBus.$emit('notify', {
      title: 'Cantonnier créé.',
      type: 'success',
    })
  },
  CANTONNIER_DEACTIVATED (state, cantonnier) {
    console.log(cantonnier)
    removeFromArray(state.cantonniers.data, cantonnier)
    state.loading.overlay = false
    EventBus.$emit('notify', {
      title: 'Cantonnier supprimé.',
      type: 'success',
    })
  },
  CANTONNIERS_DELETED (state, cantonnier) {
    state.cantonniers.data = state.cantonniers.data.filter(item => item.meta.id !== cantonnier.meta.id)
    state.loading.overlay = false
    EventBus.$emit('notify', {
      title: 'Cantonnier supprimé.',
      type: 'success',
    })
  },
  CANTONNIERS_UPDATED (state, cantonnier) {
    const index = state.cantonniers.data.map(item => item.meta.id).indexOf(cantonnier.meta.id)
    state.cantonniers.data.splice(index, 1, Object.assign(state.cantonniers.data[index], cantonnier))
    state.loading.overlay = false
    EventBus.$emit('notify', {
      title: 'Cantonnier mis à jour.',
      type: 'success',
    })
  },
  CANTONNIERS_CREATED (state, cantonnier) {
    state.cantonniers.data.unshift(cantonnier)
    state.loading.overlay = false
    EventBus.$emit('notify', {
      title: 'Cantonnier créé.',
      type: 'success',
    })
  },
  CANTONNIER_UPDATED (state, cantonnier) {
    console.log(cantonnier)
    updateArray(state.cantonniers.data, cantonnier)
    state.loading.overlay = false
    EventBus.$emit('notify', {
      title: 'Cantonnier mis à jour.',
      type: 'success',
    })
  },
  CANTONNIERS_ERROR (state, result) {
    state.loading.overlay = false
    var errorMessage = result.err.message
    if (result.err.message === 'Network Error') {
      errorMessage = 'Problème de communication avec le Backend'
    } else if (result.err.response) {
      if (result.err.response.status === 500) {
        errorMessage = 'Erreur serveur interne'
      } else if (result.err.response.status === 403) {
        errorMessage = 'Vous n\'etes pas autorisé à consulter cette page'
      } else if (result.err.response.status === 401) {
        errorMessage = 'Erreur d\'authentification'
      }
    }
    EventBus.$emit('notify', {
      title: 'Erreur lors de la ' + result.action + ' des cantonniers 😦 : ' + errorMessage,
      type: 'danger',
    })
  },

  //
  // Demandes
  //

  DEMANDES_EN_COURS_FETCHED (state, demandes) {
    state.demandesEnCours.data = demandes
    state.loading.overlay = false
    EventBus.$emit('notify', {
      title: 'Demandes en cours récupérés.',
      type: 'success',
    })
  },
  DEMANDES_FETCHED (state, demandes) {
    state.demandes.data = demandes
    state.demandes.filtredDemandes = demandes
    state.demandes.availableDates = [{id: '1', label: 'Toutes les dates', children: []},]
    state.demandes.initialDates = [{id: '1', label: 'Toutes les dates', children: []},]
    state.demandes.availablesCantonniers = [{id: '1', label: 'Tous', children: []},]
    state.demandes.initialCantonniers = [{id: '1', label: 'Tous', children: []},]

    var tempDatesMap = new Map()
    var tempCantonniersMap = new Map()

    _.map(state.demandes.data, function (demande) {
      tempDatesMap.set(demande.day, {id: demande.day, label: demande.day, isDisabled: false})
      tempCantonniersMap.set(demande.cantonnier_id, {
        id: demande.cantonnier_id,
        label: cantonnierName(demande.cantonnier_id),
        isDisabled: false
      })
    })

    state.demandes.availableDates[0].children = Array.from(tempDatesMap.values())
    state.demandes.initialDates[0].children = Array.from(tempDatesMap.values())
    state.demandes.availablesCantonniers[0].children = Array.from(tempCantonniersMap.values())
    state.demandes.initialCantonniers[0].children = Array.from(tempCantonniersMap.values())

    EventBus.$emit('notify', {
      title: 'Demandes récupérés.',
      type: 'success',
    })
    state.loading.overlay = false
    console.log('demandes => ', state.demandes)
  },

  RELOAD_DEMANDS () {
    updateDemandes()
    updateDemandesCantoFilter()
  },
  DEMANDES_ERROR (state, result) {
    state.loading.overlay = false
    var errorMessage = result.err.message
    if (result.err.message === 'Network Error') {
      errorMessage = 'Problème de communication avec le Backend'
      EventBus.$emit('notify', {
        title: 'Erreur lors de la ' + result.action + ' des demandes 😦 : ' + errorMessage,
        type: 'danger',
      })
    } else if (result.err.response) {
      if (result.err.response.status === 500) {
        errorMessage = 'Erreur serveur interne'
        EventBus.$emit('notify', {
          title: 'Erreur lors de la ' + result.action + ' des demandes 😦 : ' + errorMessage,
          type: 'danger',
        })
      } else if (result.err.response.status === 403) {
        errorMessage = 'Vous n\'etes pas autorisé à consulter cette page'
        EventBus.$emit('notify', {
          title: 'Erreur lors de la ' + result.action + ' des demandes 😦 : ' + errorMessage,
          type: 'danger',
        })
      } else if (result.err.response.status === 401) {
        errorMessage = 'Erreur d\'authentification'
        EventBus.$emit('notify', {
          title: 'Erreur lors de la ' + result.action + ' des demandes 😦 : ' + errorMessage,
          type: 'danger',
        })
      } else if (result.err.response.status === 400 && result.err.response.data.errorMessage.includes('ne peux pas')) {
        const parts = result.err.response.data.path.split('/')
        const id = parts[parts.length - 1]

        state.demandes.cancellationError = result.err.response.data.errorMessage
        let demande = state.demandes.data.find(d => d.id === id)
        console.log('demande bofore => ', demande)

        if (result.err.response.data.errorMessage.includes('Acceptée')) {
          demande.statusDemande = 'Acceptée'
        } else if (result.err.response.data.errorMessage.includes('Non réalisée')) {
          demande.statusDemande = 'Non Réalisée'
        } else if (result.err.response.data.errorMessage.includes('Réalisée')) {
          demande.statusDemande = 'Réalisée'
        } else if (result.err.response.data.errorMessage.includes('Annulée')) {
          demande.statusDemande = 'Annulée'
        } else {
          demande.statusDemande = 'Refusée'
        }
        console.log('demande after => ', demande)
        updateArray(state.demandes.data, demande)
        updateArray(state.demandes.filtredDemandes, demande)
        //  state.demandes.filters.selectedStatus = '1'
        updateDemandes()
        updateDemandesCantoFilter()

      }
    }
  },
  DEMANDE_DELETED (state, demande) {
    state.demandes.data = state.demandes.data.filter(item => item.meta.id !== demande.meta.id)
    state.loading.overlay = false
    EventBus.$emit('notify', {
      title: 'Demande annulée.',
      type: 'success',
    })
  },
  DEMANDE_UPDATED (state, demande) {
    updateArray(state.demandes.data, demande)
    updateArray(state.demandes.filtredDemandes, demande)
    state.loading.overlay = false
    EventBus.$emit('notify', {
      title: 'Demande mise à jour.',
      type: 'success',
    })
  },
  DEMANDE_CREATED (state, demande) {
    state.demandes.data.unshift(demande)

    var tempDatesMap = new Map()
    var tempCantonniersMap = new Map()

    _.map(state.demandes.data, function (demande) {
      tempDatesMap.set(demande.day, {id: demande.day, label: demande.day, isDisabled: false})
      tempCantonniersMap.set(demande.cantonnier_id, {
        id: demande.cantonnier_id,
        label: cantonnierName(demande.cantonnier_id),
        isDisabled: false
      })
    })

    if (state.demandes.availableDates && state.demandes.availablesCantonniers && state.demandes.initialCantonniers && state.demandes.initialDates) {
      state.demandes.availableDates[0].children = Array.from(tempDatesMap.values())
      state.demandes.initialDates[0].children = Array.from(tempDatesMap.values())
      state.demandes.availablesCantonniers[0].children = Array.from(tempCantonniersMap.values())
      state.demandes.initialCantonniers[0].children = Array.from(tempCantonniersMap.values())
    }

    state.loading.overlay = false
    EventBus.$emit('notify', {
      title: 'Demande créée.',
      type: 'success',
    })
  },
  DEMANDE_CANCELED (state, demande) {
    state.loading.overlay = false
    updateArray(state.demandes.data, demande)
    updateArray(state.demandes.filtredDemandes, demande)
    EventBus.$emit('notify', {
      title: 'Demande mise à jour.',
      type: 'success',
    })
  },
  DEMANDE_CANCELLATION_CLEAR (state) {
    state.demandes.cancellationError = ''
  },

  //
  // ADMINISTRATION
  //

  MODULE_BO_UPDATED (state, {module, selectedVille}) {
    console.log('state.villes.data => ', state.villes.data)
    console.log('module => ', module)
    console.log('selectedVille => ', selectedVille)
    const index = state.villes.data.map(item => item.id).indexOf(module.ville_id)
    console.log('index => ', index)
    updateVillesArray(state.villes.data[index].parametragebos, module)
    updateVillesArray(state.villes.availableVilles[index].parametragebos, module)

    state.loading.overlay = false
    EventBus.$emit('notify', {
      title: 'Ville mis à jour.',
      type: 'success',
    })
    if (state.currentVille.id === selectedVille.id) {
      state.currentVille.moduleBackoffice = state.villes.data[index].parametragebos
    }

  },
  KPI (state, kpi) {
    console.log('KPI =>', kpi)
    state.statistiques = {}
    state.statistiques.dataTournees = kpi.nbTournees
    state.statistiques.dataDemandes = kpi.nbDemandes
    state.statistiques.dataSignalements = kpi.nbDeclarations
  },
  MODULE_APK_UPDATED (state, module) {
    const index = state.villes.data.map(item => item.id).indexOf(module.ville_id)
    updateVillesArray(state.villes.data[index].parametrageapks, module)
    updateVillesArray(state.villes.availableVilles[index].parametrageapks, module)

    state.loading.overlay = false
    EventBus.$emit('notify', {
      title: 'Ville mis à jour.',
      type: 'success',
    })
  },

  //
  // Notification
  //

  NOTIFICATION_CREATED (state, notification) {
    EventBus.$emit('notify', {
      title: 'Notification créée et envoyée au cantonnier.',
      type: 'success',
    })
  },
  NOTIFICATION_UPDATED (state, notification) {
    EventBus.$emit('notify', {
      title: 'Notification mis à jour.',
      type: 'success',
    })
  },
  NOTIFICATION_ERROR (state) {
    EventBus.$emit('notify', {
      title: 'Erreur lors de la mise à jour de la notification.',
      type: 'danger',
    })
  },
  NOTIFICATION_DELETED (state) {
    EventBus.$emit('notify', {
      title: 'Notification supprimée',
      type: 'success',
    })
  },

  //
  // Map
  //

  REALTIME_TOURNEES (state, tournees) {
    console.log('secteurs of ville => ', state.currentVille.secteurs)
    console.log('state.currentUser.arrondissementName => ', state.currentUser.arrondissementName)
    console.log('state.currentUser.role => ', state.currentUser.role)

    if (state.currentUser.arrondissementName.includes('2') || state.currentUser.arrondissementName.includes('Sud')) {
      let filtredTournees = []
      tournees.forEach((t) => {

        let arrondissement = state.currentVille.secteurs.find(s => s.id === t.remonteeGPSs[0].secteur_id).arrondissement_id
        if (arrondissement === state.currentUser.arrondissement_id) {
          filtredTournees.push(t)
        }
      })

      state.map.realTimeTournees = filtredTournees

    } else {
      state.map.realTimeTournees = tournees
    }

    console.log("Ressult => " , state.map.realTimeTournees)
  },
  MAP_FILTER (state, infos) {
    state.map.filters[infos.filterKey] = infos.value
  },
  MAP_CLEAR (state) {
    state.map.searching = false
    state.map.result = null
    state.map.message = null
    state.map.filters = {
      date: new Date(),
      idAgent: null,
      idRonde: null,
    }
  },
  MAP_SEARCHING (state) {
    state.map.searching = true
  },
  MAP_RESULT (state, res) {
    state.map.message = null
    state.map.searching = false
    state.map.result = res
    state.map.mode = res.mode
    if (res.geopassages && res.geopassages.length === 0) {
      state.map.message = {
        text: 'Aucun point GPS correspondant',
        type: 'warning',
      }
    }
    EventBus.$emit('reload', {})
  },
  MAP_REALTIME_RESULTS (state, realtimeGeopassages) {
    state.map.realtimeGeopassages = realtimeGeopassages
    state.map.message = null
  },
  MAP_IMPLENTATIONMAT_RESULTS (state, implGeopassages) {
    _.each(implGeopassages, function (mat) {
      mat.opened = false
    })
    state.implentationMaterielGeopassages.data = implGeopassages
    state.map.message = null
  },
  MAP_ADD (state, res) {  // Alimente le tableau des geopassages de la carte au lieu de le réinitialiser
    if (!state.map.result) {
      state.map.result = {
        geopassages: [],
      }
      if (state.map.mode) {
        state.map.mode = res.mode
      }
    }
    if (res.finTournee && res.finTournee.results) {
      res.debutTournee.finTournee = res.finTournee.results[0]
    }
    state.map.result.geopassages = state.map.result.geopassages.concat(res.debutTournee)
    console.log('all geopassages => ', state.map.result.geopassages)
    EventBus.$emit('reload', {})
  },
  MAP_MESSAGE (state, message) {
    state.map.message = message
    state.map.searching = false
    state.map.result = null
  },

  //
  // CSV reporting
  //

  CSV_SUCCESS (state) {
    state.loading.overlay = false
    EventBus.$emit('notify', {
      title: 'Rapport CSV généré.',
      type: 'success',
    })
  },
  CSV_ERROR (state, message) {
    state.loading.overlay = false
    state.map.message = {
      text: message,
      type: 'danger',
    }
    EventBus.$emit('notify', {
      title: message,
      type: 'danger',
    })
  },
  CSV_ERROR_UNDEFINED (state, message) {
    state.loading.overlay = false
    state.map.message = {
      text: message,
      type: 'error',
    }
    EventBus.$emit('notify', {
      title: message,
      type: 'error  ',
    })
  },
  REPORTING_FETCHED (state) {
    state.loading.overlay = false
    EventBus.$emit('notify', {
      title: 'Données de génération de reporting récupérées.',
      type: 'success',
    })
  },
  REPORTING_ERROR (state) {
    state.loading.overlay = false
    /*     EventBus.$emit('notify', {
          title: 'Erreur à la récupération des données pour le reporting',
          type: 'danger',
        }) */

  },
  REPORTING_EMPTY (state) {
    state.loading.overlay = false
    EventBus.$emit('notify', {
      title: 'Aucune donnée ne correspond à votre sélection',
      type: 'danger',
    })
  },
  REPORTING_FILTERMATERIELS (state, mat) {
    state.reportingFilter.materiels = _.cloneDeep(mat)
  },

  //
  // Users
  //

  USERS_CLEARED (state) {
    state.allUsers.data = []
  },
  USER_CREATED (state, result) {
    state.adminUsers.data.unshift(result)

    let sortedData = [...state.adminUsers.data].sort((a, b) => a.nom.localeCompare(b.nom))
    state.adminUsers.treeSelectAdminUsers = [{id: '1', label: 'Tous les maitrises', children: []},]
    var tempMaitrisesMap = new Map()
    sortedData.forEach((mait) => {
      tempMaitrisesMap.set(mait.id, {id: mait.id, label: mait.nom + ' ' + mait.prenom})
    })
    state.adminUsers.treeSelectAdminUsers[0].children = Array.from(tempMaitrisesMap.values())

    state.loading.overlay = false
    EventBus.$emit('notify', {
      title: 'Maîtrise créé.',
      type: 'success',
    })
  },
  USER_DELETED (state, maitrise) {
    console.log('deleted this', maitrise.id)
    maitrise.deleted = true
    updateArray(state.adminUsers.data, maitrise)
    updateArray(state.adminUsers.filteredAdminUsers, maitrise)
    console.log('state allUsers ========', state.allUsers)
    state.loading.overlay = false
    EventBus.$emit('notify', {
      title: 'Maîtrise supprimé définitivement.',
      type: 'success',
    })
  },
  USER_UPDATED (state, maitrise) {
    console.log(maitrise)
    updateArray(state.adminUsers.data, maitrise)
    updateArray(state.adminUsers.filteredAdminUsers, maitrise)
    state.loading.overlay = false
    EventBus.$emit('notify', {
      title: 'Maîtrise mis à jour.',
      type: 'success',
    })
  },
  USER_DEACTIVATED (state, maitrise) {
    console.log('deactivated this', maitrise.id)
    updateArray(state.adminUsers.data, maitrise)
    updateArray(state.adminUsers.filteredAdminUsers, maitrise)
    console.log('state allUsers ========', state.allUsers)
    state.loading.overlay = false
    EventBus.$emit('notify', {
      title: 'Maîtrise supprimé.',
      type: 'success',
    })
  },
  USERS_FETCHED (state, users) {
    console.log('Maitrises from mutation => ', users)
    state.adminUsers.filters.idUsers = []
    state.adminUsers.data = users
    state.adminUsers.filteredAdminUsers = users
    state.adminUsers.treeSelectAdminUsers = [{id: '1', label: 'Tous les maitrises', children: []},]
    var tempMaitrisesMap = new Map()
    users.forEach((mait) => {
      tempMaitrisesMap.set(mait.id, {id: mait.id, label: mait.nom + ' ' + mait.prenom})
    })
    state.adminUsers.treeSelectAdminUsers[0].children = Array.from(tempMaitrisesMap.values())
    state.loading.overlay = false
  },
  USERS_ERROR (state, result) {
    state.loading.overlay = false
    var errorMessage = result.err.message
    if (result.err.message === 'Network Error') {
      errorMessage = 'Problème de communication avec le Backend'
    } else if (result.err.response) {
      if (result.err.response.status === 500) {
        errorMessage = 'Erreur serveur interne'
      } else if (result.err.response.status === 403) {
        errorMessage = 'Vous n\'etes pas autorisé à consulter cette page'
      } else if (result.err.response.status === 401) {
        errorMessage = 'Erreur d\'authentification'
      } else if (result.err.response.status === 409) {
        errorMessage = 'Une maitrise avec le même Login/Email existe déjà dans la BD'
      }
    }
    EventBus.$emit('notify', {
      title: 'Erreur lors de la ' + result.action + ' des maîtrises 😦 : ' + errorMessage,
      type: 'danger',
    })
  },

  //
  // VILLES
  //

  ALL_VILLES_FETCHED (state, villes) {

    _.map(villes, function (ville) {
      ville.parametragebos = ville.parametragebos.sort((a, b) => a.order - b.order)
      ville.parametrageapks = ville.parametrageapks.sort((a, b) => a.order - b.order)
    })
    state.villes.availableVilles = _.cloneDeep(villes)
    state.villes.data = villes
    state.loading.overlay = false

  },
  VILLES_CLEARED (state) {
    state.villes.data = []
  },
  VILLES_FETCHED (state, villes) {
    state.villes.data = villes
    state.loading.overlay = false
    EventBus.$emit('notify', {
      title: 'Récupération des villes.',
      type: 'success',
    })
  },
  VILLES_UPDATED () {
    EventBus.$emit('notify', {
      title: 'Ville mis à jour.',
      type: 'success',
    })
  },
  VILLES_ERROR (state, result) {
    console.error(result.err)
    state.loading.overlay = false
    EventBus.$emit('notify', {
      title: 'Erreur à la récupération des villes =(',
      type: 'danger',
    })
  },
  REPORTING_FILTER_DATES (state, daysList) {
    state.reportingFilter.dates = daysList
    state.loading.overlay = false
  },
  REPORTING_FILTER_AGENTS (state, cantonniers) {
    state.reportingFilter.agents = [
      {
        id: '1',
        label: 'Tous',
        children: cantonniers.filter(item => !item.isDisabled)
      }
    ]
  },
  REPORTING_FILTER_MATERIELS (state, mat) {
    state.reportingFilter.materiels = _.cloneDeep(mat)
  },
  TOURNEE_CLOSED (state, tournee) {
      console.log(tournee)
      removeFromArray(state.tournees.data, tournee)
      //updateArray(state.tournees.data, tournee)
      console.log(state.tournees.data)
      console.log(tournee)
      state.loading.overlay = false
      EventBus.$emit('notify', {
        title: 'Tournée clôturée.',
        type: 'success',
      })
    },
    TOURNEE_ERROR (state, err) {
        console.error(err)
        state.loading.overlay = false
        EventBus.$emit('notify', {
          title: 'Erreur à la clôture de la tournée =(',
          type: 'danger',
        })
      },

}

function updateArray (elements, element) {
  const index = elements.map(item => item.id).indexOf(element.id)
  if (index > -1) {
    elements.splice(index, 1, Object.assign(elements[index], element))
  }
}

function removeFromArray (elements, element) {
  const index = elements.map(item => item.id).indexOf(element.id)
  if (index > -1) {
    elements.splice(index, 1)
  }
}

function updateVillesArray (params, module) {
  const index = params.map(item => item.id).indexOf(module.id)
  if (index > -1) {
    params.splice(index, 1, Object.assign(params[index], module))
  }
}

function setAccess (state, backOfficeModules) {
  _.map(backOfficeModules, function (module) {
    switch (module.nom) {
      case 'map' :
        state.map.actif = module.actif
        break
      case 'realtime':
        state.realtime.actif = module.actif
        break
      case 'reporting':
        state.reporting.actif = module.actif
        break
      case 'materiels':
        state.materiel.actif = module.actif
        break
      case 'maitrises':
        state.maitrises.actif = module.actif
        break
      case 'implantation_des_contenants':
        state.implentationMaterielGeopassages.actif = module.actif
        break
      case 'cantonniers':
        state.cantonniers.actif = module.actif
        break
      case 'secteurs':
        state.secteurs.actif = module.actif
        break
      case 'demandes':
        state.demandes.actif = module.actif
        break
      case 'contenants':
        state.collectes.actif = module.actif
        break
    }
  })
}

function getSecteurName (id_secteur) {
  console.log("id_secteur : " ,id_secteur )
  console.log("state.secteurs : " ,state.secteurs.data )
  return state.secteurs.data.find(arr => arr.id === id_secteur).nom
}

function updateDemandesCantoFilter () {
  const cantonniersToRemove = []
  const datesToRemove = []
  var removeFromArray = function (arr, elem) {
    console.log(arr, elem)
    const idx = arr.indexOf(elem)
    if (idx !== -1) arr.splice(idx, 1)
  }

  // update cantoniers drop-down list
  _.each(state.demandes.availablesCantonniers[0].children, function (canto) {
    // console.log(canto)
    var founded = !_.find(state.demandes.filtredDemandes, function (demande) {
      // console.log(demande.cantonnier.nom)
      return demande.cantonnier_id === canto.id
    })
    if (founded) {
      canto.isDisabled = true
      cantonniersToRemove.push(canto.id)
      console.log(state.demandes.filters.idCantonniers, canto.id)
      removeFromArray(state.demandes.filters.idCantonniers, canto.id)
    } else {
      canto.isDisabled = false
    }
    state.demandes.availablesCantonniers[0].children = state.demandes.availablesCantonniers[0].children.filter(canto => {
      return !cantonniersToRemove.includes(canto.id)
    })
  })
  console.log('deb-demande => ', state.demandes.availablesCantonniers[0].children)
  // update days drop-down list
  _.each(state.demandes.availableDates[0].children, function (date) {
    var founded = !_.find(state.demandes.filtredDemandes, function (demande) {
      return demande.day === date.id
    })
    if (founded) {
      date.isDisabled = true
      datesToRemove.push(date.id)
      removeFromArray(state.demandes.filters.daysList, date.id)
    } else {
      date.isDisabled = false
    }
    state.demandes.availableDates[0].children = state.demandes.availableDates[0].children.filter(date => {
      return !datesToRemove.includes(date.id)
    })
  })
}

function updateDemandes () {
  if (state.demandes.filters.selectedStatus !== '1') {
    state.demandes.filtredDemandes = _.filter(state.demandes.data, function (demande) {
      return demande.statusDemande === state.demandes.filters.selectedStatus
    })
  } else {
    state.demandes.filtredDemandes = state.demandes.data
  }
  // // Demandes filtred by Canto
  if (state.demandes.filters.idCantonniers.length > 0) {
    state.demandes.filtredDemandes = _.filter(state.demandes.filtredDemandes, function (demande) {
      return _.find(state.demandes.filters.idCantonniers, function (canto) {
        return demande.cantonnier_id === canto
      })
    })
  } else {
    state.demandes.availablesCantonniers = _.cloneDeep(state.demandes.initialCantonniers)
  }
  // Demandes filtred by dates
  if (state.demandes.filters.daysList.length > 0) {
    state.demandes.filtredDemandes = _.filter(state.demandes.filtredDemandes, function (demande) {
      return _.find(state.demandes.filters.daysList, function (day) {
        return demande.day === day
      })
    })
  } else {
    state.demandes.availableDates = _.cloneDeep(state.demandes.initialDates)
  }
}




// WEBPACK FOOTER //
// ./src/store/mutations.js